import { Controller } from '@hotwired/stimulus'
import position from '@yaireo/position'
// eslint-disable-next-line camelcase
import ColorPicker, { any_to_hex } from '@yaireo/color-picker'

export default class extends Controller {
  static targets = ['picker', 'input']

  connect () {
    this.cPicker = this.#createColorPicker()
    document.addEventListener('turbo:morph', this.reconnect.bind(this))
  }

  disconnect () {
    this.cPicker = undefined
  }

  convert () {
    const inputValue = any_to_hex(this.inputTarget.value)
    const pickerValue = any_to_hex(this.cPicker.CSSColor)

    if (pickerValue !== inputValue) { this.cPicker.setColor(inputValue) }
  }

  show () {
    this.pickerTarget.click()
  }

  reconnect () {
    this.disconnect()
    this.connect()
  }

  #createColorPicker () {
    return new ColorPicker({
      color: this.pickerTarget.value,
      defaultFormat: 'hex',
      swatches: this.#getSwatches(),
      swatchesLocalStorage: true,
      buttons: this.#getButtonsConfig(),
      onClickOutside: this.#onClickOutside.bind(this),
      onInput: this.#onInput.bind(this)
    })
  }

  #getSwatches () {
    const defaultSwatches = ['#3F3C43', '#65adff']
    const swatches = this.pickerTarget.dataset.swatches
      ? JSON.parse(this.pickerTarget.dataset.swatches)
      : []
    return [...swatches, ...defaultSwatches]
  }

  #getButtonsConfig () {
    return {
      undo: { icon: '↶', title: 'Undo' },
      add: { icon: '+', title: 'Add to Swatches' },
      format: { icon: '⇆', title: 'Switch Color Format' }
    }
  }

  #observerCallback () {
    if (!this.cPicker.DOM.scope.classList.contains('hidden')) {
      position({
        target: this.cPicker.DOM.scope,
        ref: this.pickerTarget,
        placement: this.pickerTarget.dataset.placement || 'center below',
        offset: [20]
      })
    }
  }

  #onClickOutside (e) {
    const pickerElem = this.cPicker.DOM.scope
    const isClickOnInputOrPicker = e.target === this.pickerTarget || e.target === this.inputTarget
    const isClickInsidePicker = pickerElem.contains(e.target)
    let showPicker = isClickOnInputOrPicker || isClickInsidePicker

    if (e.key === 'Escape') showPicker = false

    if (showPicker) {
      this.#showColorPicker(pickerElem)
    } else {
      this.#hideColorPicker(pickerElem)
    }

    if (isClickOnInputOrPicker) this.#observerCallback()
  }

  #onInput (color) {
    this.pickerTarget.value = color
    this.inputTarget.value = color
    this.pickerTarget.style.backgroundColor = color
    this.element.style.setProperty('--colorPickerSelectedColor', color)
  }

  #showColorPicker (pickerElem) {
    if (!document.body.contains(pickerElem)) {
      document.body.appendChild(pickerElem)
    }

    this.#observerCallback()
  }

  #hideColorPicker (pickerElem) {
    pickerElem.remove()
  }
}
